exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".otp[data-v-670cb302]{transition:none;max-width:300px;font-size:24px}[data-v-670cb302]::-webkit-input-placeholder{font-size:18px!important}[data-v-670cb302]::-moz-placeholder{font-size:18px!important}[data-v-670cb302]:-ms-input-placeholder{font-size:18px!important}[data-v-670cb302]:-moz-placeholder{font-size:18px!important}", ""]);

// exports
